import React from "react";
import { Link } from "react-router-dom";
import { useAuthentication } from "@repo/core";

const Unauthorized: React.FC = () => {
  const { user, logOut } = useAuthentication();

  const handleLogout = () => {
    logOut();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="text-6xl text-red-500 mb-4">🚫</div>
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
            Access Denied
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            You don't have permission to access this page.
          </p>
        </div>

        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {user && (
            <div className="mb-6">
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Current User:
              </h3>
              <div className="text-sm text-gray-600">
                <p>
                  <strong>Name:</strong> {user.name}
                </p>
                <p>
                  <strong>Email:</strong> {user.email}
                </p>
                <p>
                  <strong>Roles:</strong> {user.roles.join(", ")}
                </p>
                <p>
                  <strong>Permissions:</strong> {user.permissions.join(", ")}
                </p>
              </div>
            </div>
          )}

          <div className="space-y-4">
            <div>
              <Link
                to="/"
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Go to Dashboard
              </Link>
            </div>

            <div>
              <button
                onClick={handleLogout}
                className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Logout and Login as Different User
              </button>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Contact your administrator if you believe you should have access to
            this page.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
